const defaultIfEmpty = (value, fallback) => (value === '' ? fallback : value);
const booleanValue = (value, fallback = true) => {
  if (value === '') return fallback;
  if (typeof value === 'string') return value.toLowerCase() !== 'false' && value !== '0';
  return Boolean(value);
};

const valueOf = (source, camelKey, snakeKey = camelKey) => {
  if (source?.[camelKey] !== undefined && source?.[camelKey] !== null) return source[camelKey];
  if (source?.[snakeKey] !== undefined && source?.[snakeKey] !== null) return source[snakeKey];
  return '';
};

export const EMPTY_PARTNER_QUOTE_SETTINGS = {
  enabled: true,
  globalDiscountKind: 'percent',
  globalDiscountValue: 0,
  paymentTerms: '',
  paymentDelayDays: '',
  depositRate: 0,
  validityDays: 30,
  defaultVatRate: 20,
  currencyCode: 'EUR',
  laborCoefficient: '',
  materialCoefficient: '',
  subcontractingCoefficient: '',
  coContractingCoefficient: '',
  materialPurchaseDiscountRate: 0,
  notes: '',
};

export const normalizePartnerQuoteSettings = (settings = {}) => ({
  enabled: booleanValue(valueOf(settings, 'enabled')),
  globalDiscountKind: valueOf(settings, 'globalDiscountKind', 'global_discount_kind') || 'percent',
  globalDiscountValue: valueOf(settings, 'globalDiscountValue', 'global_discount_value') || 0,
  paymentTerms: valueOf(settings, 'paymentTerms', 'payment_terms'),
  paymentDelayDays: valueOf(settings, 'paymentDelayDays', 'payment_delay_days'),
  depositRate: valueOf(settings, 'depositRate', 'deposit_rate') || 0,
  validityDays: defaultIfEmpty(valueOf(settings, 'validityDays', 'validity_days'), 30),
  defaultVatRate: defaultIfEmpty(valueOf(settings, 'defaultVatRate', 'default_vat_rate'), 20),
  currencyCode: valueOf(settings, 'currencyCode', 'currency_code') || 'EUR',
  laborCoefficient: valueOf(settings, 'laborCoefficient', 'labor_coefficient'),
  materialCoefficient: valueOf(settings, 'materialCoefficient', 'material_coefficient'),
  subcontractingCoefficient: valueOf(settings, 'subcontractingCoefficient', 'subcontracting_coefficient'),
  coContractingCoefficient: valueOf(settings, 'coContractingCoefficient', 'co_contracting_coefficient'),
  materialPurchaseDiscountRate: valueOf(settings, 'materialPurchaseDiscountRate', 'material_purchase_discount_rate') || 0,
  notes: valueOf(settings, 'notes'),
  updatedAt: valueOf(settings, 'updatedAt', 'updated_at'),
  updatedBy: valueOf(settings, 'updatedBy', 'updated_by'),
});

export const buildPartnerQuoteSettingsPayload = (settings = {}) => {
  const normalized = normalizePartnerQuoteSettings(settings);
  return {
    enabled: normalized.enabled,
    globalDiscountKind: normalized.globalDiscountKind,
    globalDiscountValue: normalized.globalDiscountValue,
    paymentTerms: normalized.paymentTerms,
    paymentDelayDays: normalized.paymentDelayDays === '' ? null : normalized.paymentDelayDays,
    depositRate: normalized.depositRate,
    validityDays: normalized.validityDays,
    defaultVatRate: normalized.defaultVatRate,
    currencyCode: normalized.currencyCode,
    laborCoefficient: normalized.laborCoefficient === '' ? null : normalized.laborCoefficient,
    materialCoefficient: normalized.materialCoefficient === '' ? null : normalized.materialCoefficient,
    subcontractingCoefficient: normalized.subcontractingCoefficient === '' ? null : normalized.subcontractingCoefficient,
    coContractingCoefficient: normalized.coContractingCoefficient === '' ? null : normalized.coContractingCoefficient,
    materialPurchaseDiscountRate: normalized.materialPurchaseDiscountRate,
    notes: normalized.notes,
  };
};
